globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
export var BackIcon = function BackIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.2949 18.7046L6.14338 13.5531L5.28983 12.6995H6.49693H20.4001C20.5858 12.6995 20.7638 12.6258 20.8951 12.4945C21.0264 12.3632 21.1001 12.1852 21.1001 11.9995C21.1001 11.8139 21.0264 11.6358 20.8951 11.5045C20.7638 11.3733 20.5858 11.2995 20.4001 11.2995H6.49693H5.28983L6.14338 10.446L11.2915 5.29783C11.4174 5.16611 11.4869 4.99045 11.4854 4.80818C11.4838 4.62464 11.4101 4.44907 11.2804 4.31928C11.1506 4.1895 10.975 4.11588 10.7915 4.11428C10.6092 4.1127 10.4335 4.18228 10.3018 4.30815L3.10534 11.5046C3.10532 11.5046 3.10531 11.5046 3.10529 11.5047C2.97409 11.6359 2.90039 11.8139 2.90039 11.9995C2.90039 12.1851 2.97409 12.3631 3.10529 12.4944L11.2949 18.7046ZM11.2949 18.7046C11.2949 18.7046 11.295 18.7046 11.295 18.7047C11.4262 18.8359 11.4999 19.0139 11.4999 19.1995C11.4999 19.3851 11.4262 19.5631 11.2949 19.6944C11.1637 19.8256 10.9857 19.8993 10.8001 19.8993C10.6145 19.8993 10.4366 19.8256 10.3053 19.6944C10.3053 19.6943 10.3053 19.6943 10.3052 19.6943L3.10534 12.4944L11.2949 18.7046Z",
      fill: "#111928",
      stroke: "#111928"
    })
  });
};